import { CircleAlertIcon } from 'lucide-react';
import { useCallback, useState } from 'react';
import { ValidationError } from 'yup';

import styles from '../password-recovery.module.scss';
import CustomInput from '../../../components/custom-input/custom-input.component';
import BasicButton from '../../../components/basic-button/basic-button.component';
import { formSchema } from '../utils';

type Props = {
    loading: boolean;
    onUpdatePassword: (password: string) => void;
};

const ChangePasswordForm = ({ loading, onUpdatePassword }: Props) => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const checkForm = useCallback(
        (password: string, confirmPassword: string) => {
            try {
                formSchema.validateSync({
                    password,
                    confirmPassword,
                });
                if (password !== confirmPassword) {
                    setErrorMessage('Las contraseñas no coinciden');
                    return false;
                }
                return true;
            } catch (err) {
                const error = err as ValidationError;
                setErrorMessage(error.message);
                return false;
            }
        },
        []
    );

    const handleUpdate = useCallback(() => {
        if (!checkForm(password, confirmPassword)) return;
        return onUpdatePassword(password);
    }, [password, confirmPassword]);

    return (
        <form>
            <div className={styles.row}>
                <label>Nueva contraseña</label>
                <CustomInput
                    width="100%"
                    value={password}
                    onChange={setPassword}
                />
            </div>
            <div className={styles.row}>
                <label>Confirmar contraseña</label>
                <CustomInput
                    width="100%"
                    value={confirmPassword}
                    onChange={setConfirmPassword}
                />
            </div>
            {errorMessage && (
                <div className={styles.errorMessage}>
                    <CircleAlertIcon size={16} />
                    <span>{errorMessage}</span>
                </div>
            )}
            <BasicButton
                disabled={loading}
                width="100%"
                style={{ height: 40 }}
                onClick={handleUpdate}
            >
                {loading ? 'Cargando...' : 'Confirmar'}
            </BasicButton>
        </form>
    );
};

export default ChangePasswordForm;
